import VertexShader from "./shaders/scaled-background.vs";
import FragmentShader from "./shaders/base-overlay.fs";
import Utils from "../utils";

class ScaledBackgroundMaterial extends THREE.ShaderMaterial {
    constructor() {
        const uniforms = {
            map: new THREE.Uniform(null),
            viewport: new THREE.Uniform(new THREE.Vector4(0, 0, 1, 1))
        };

        const defines = {};

        if (Utils.queryParams.has("debug_viewport_size")) defines.DEBUG_OVERLAY = "";

        super({
            uniforms,
            defines,
            vertexShader: VertexShader,
            fragmentShader: FragmentShader
        });
    }

    setMap(tex) { this.uniforms.map.value = tex; }
}

export default ScaledBackgroundMaterial;
export { ScaledBackgroundMaterial };